/** Célméret karakterben; átfedés a határmenti mondatokhoz. */
export const CHUNK_SIZE = 1000;
export const CHUNK_OVERLAP = 200;

/**
 * Átfedéses darabolás. Rövid szöveg → egyetlen chunk.
 * Üres / csak whitespace → üres tömb.
 */
export function chunkText(text: string, size = CHUNK_SIZE, overlap = CHUNK_OVERLAP): string[] {
  const normalized = text.replace(/\r\n/g, "\n").replace(/[ \t]+\n/g, "\n").trim();
  if (!normalized) return [];
  if (normalized.length <= size) return [normalized];

  const safeOverlap = Math.max(0, Math.min(overlap, size - 1));
  const chunks: string[] = [];
  let start = 0;
  while (start < normalized.length) {
    let end = Math.min(normalized.length, start + size);
    if (end < normalized.length) {
      const window = normalized.slice(start, end);
      const breakAt = Math.max(window.lastIndexOf("\n\n"), window.lastIndexOf("\n"), window.lastIndexOf(". "));
      if (breakAt > size * 0.5) end = start + breakAt + 1;
    }
    const piece = normalized.slice(start, end).trim();
    if (piece) chunks.push(piece);
    if (end >= normalized.length) break;
    start = Math.max(start + 1, end - safeOverlap);
  }
  return chunks;
}
